import React from "react";
import TempParticpantCard from "./TempParticipantCard";

const TempParticpantGrid = ({participants, event}) => {
  return (
    <div style={{ display: "flex", justifyContent: "spaceBetween", width:"100%" }}>
    <div style={{
      display: "grid",
      justifyContent: "spaceBetween",    
      width: "100%"
    }}>

        <TempParticpantCard
            uniqueID="Unique ID" 
            name="Name"
            dob="Date of Birth"
            waiver="Signed Waiver"
            event="Signed Waiver"
          />
        
      {participants.map((p) => {


        return (
          <TempParticpantCard
            uniqueID={p.uniqueID} 
            name={p.fullName}
            dob={p.dateOfBirth}
            waiver={p.waiver}
            event={event}
          />
        );
      })}
    </div>
     </div> 
  );

};

export default TempParticpantGrid;